
    const { assign, transform, isObject, isArray } = require("!../../../../../node_modules/lodash/lodash.js");
    const classNames = require("!../../../../../node_modules/classnames/bind.js");
    const locals = require("!!../../../../../node_modules/style-loader/index.js!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[3].use[3]!../../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[4]!./bottom.scss");
    const bound = classNames.bind(locals);
    const css = (...array) => bound(array.map(sanitize));

    module.exports = assign(css, locals, { locals });

    function sanitize(arg) {
      if (isObject(arg) && !isArray(arg)) {
        return transform(arg, (result, value, key) => {
          if (key == 'className') {
            result[value] = true;
          } else if (value === true) {
            result[key] = true;
          }
        });
      }
      return arg;
    }
  